export default async function fetchBotStatus(url) {
  try {
    const response = await fetch(`${import.meta.env.VITE_APP_API_URL}${url}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error en la solicitud:', error);
    return false;
  }
}